import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagC = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2056_28814)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
			fill: "#008059"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.26183 12.2671C7.69369 12.2671 7.18156 12.179 6.72545 12.003C6.26934 11.819 5.88124 11.5509 5.56116 11.1988C5.24108 10.8387 4.99302 10.3946 4.81697 9.86647C4.64093 9.33033 4.55291 8.70618 4.55291 7.994C4.55291 7.28982 4.64093 6.66567 4.81697 6.12153C4.99302 5.56939 5.24108 5.10928 5.56116 4.74119C5.88124 4.36509 6.26934 4.08102 6.72545 3.88897C7.18156 3.69692 7.69369 3.6009 8.26183 3.6009C9.03803 3.6009 9.67819 3.76094 10.1823 4.08102C10.6864 4.3931 11.0905 4.88922 11.3946 5.56939L9.82222 6.3856C9.7102 6.03351 9.53415 5.75344 9.29409 5.54539C9.06203 5.32933 8.71795 5.2213 8.26183 5.2213C7.7257 5.2213 7.29359 5.39735 6.96551 5.74944C6.64543 6.09352 6.48539 6.59765 6.48539 7.26182V8.60615C6.48539 9.27032 6.64543 9.77844 6.96551 10.1305C7.29359 10.4746 7.7257 10.6467 8.26183 10.6467C8.70995 10.6467 9.06603 10.5266 9.3301 10.2866C9.60217 10.0385 9.80222 9.74244 9.93025 9.39835L11.4186 10.2626C11.1065 10.9027 10.6944 11.3988 10.1823 11.7509C9.67819 12.095 9.03803 12.2671 8.26183 12.2671Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2056_28814",
		children: /* @__PURE__ */ _jsx("rect", {
			fill: "white",
			height: 16,
			width: 16
		})
	}) })]
});
export default SvgFlagC;
